import { render } from "./EntryQuestionWaitFirst.vue?vue&type=template&id=69d6b75c"
import script from "./EntryQuestionWaitFirst.vue?vue&type=script&lang=js"
export * from "./EntryQuestionWaitFirst.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src882003474/src/vote-screen-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__